function withoutProperties(object, properties) {
  var result = {};

  for (var property in object) {
    if (object.hasOwnProperty(property) && !properties[property])
      result[property] = object[property];
  }

  return result;
}

module.exports = withoutProperties;



//////////////////
// WEBPACK FOOTER
// ./~/react-router/modules/helpers/withoutProperties.js
// module id = 187
// module chunks = 0